import React from 'react'
import PropTypes from 'prop-types'
import InfiniteLoader from 'react-virtualized/dist/commonjs/InfiniteLoader/InfiniteLoader'
import { compose, setDisplayName, withHandlers, withProps, withState, pure } from 'recompose'

import { promiseQueue } from 'utils/helpers/promiseQueue'
import { DEFAULT_LIST_SIZE } from 'store/common/constants/generic'
import { withComponentWillUnmount } from 'hoc/withComponentWillUnmount'
import { loadMoreRowsHandler } from 'components/list/helpers/infiniteListHelpers'
import { List } from 'components/list'

const InfiniteListCmp = ({
  list,
  loadMoreRowsHandler,
  isRowLoaded = ({ index }) => !!list[index],
  totalCount = list.length,
  threshold,
  ...listProps
}) => (
  <InfiniteLoader
    isRowLoaded={isRowLoaded}
    loadMoreRows={loadMoreRowsHandler}
    rowCount={totalCount}
    threshold={threshold}>
    {({ onRowsRendered, registerChild }) => (
      <List
        list={list}
        registerChild={registerChild}
        onRowsRendered={onRowsRendered}
        rowCount={totalCount}
        {...listProps}
      />
    )}
  </InfiniteLoader>
)

InfiniteListCmp.propTypes = {
  ...List.propTypes,
  loadMoreRowsHandler: PropTypes.func.isRequired,
  isRowLoaded: PropTypes.func,
  totalCount: PropTypes.number.isRequired,
  overscanRowCount: PropTypes.number.isRequired,
}

const handleComponentWillUnmount = ({ promiseQueue }) => {
  promiseQueue.cancel()
}

export const InfiniteList = compose(
  setDisplayName('InfiniteList'),
  pure,
  withState('page', 'setPage', 0),
  // NOTE: not using `setPromiseQueue` because of promiseQueue set queue inside itself
  withState('promiseQueue', 'setPromiseQueue', () => promiseQueue()),
  // add overscanRowCount for correct page loading in `loadMoreRowsHandler` method
  withProps(({ overscanRowCount = DEFAULT_LIST_SIZE, threshold = overscanRowCount / 2, ...otherProps }) => ({
    // next page will start loading if user scrolls a half of current page
    overscanRowCount,
    threshold,
    ...otherProps,
  })),
  withHandlers({
    loadMoreRowsHandler,
  }),
  withComponentWillUnmount(handleComponentWillUnmount),
)(InfiniteListCmp)
